import { render, staticRenderFns } from "./sceltaDdtDettaglio.vue?vue&type=template&id=38428a1a"
import script from "./sceltaDdtDettaglio.vue?vue&type=script&lang=js"
export * from "./sceltaDdtDettaglio.vue?vue&type=script&lang=js"
import style0 from "./sceltaDdtDettaglio.vue?vue&type=style&index=0&id=38428a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports